<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <app-section-header
          [title]="'grid-comp.concept-of-measurement' | translate"
          [tooltip]="'tooltips.technical-data.concept-of-measurement' | translate"></app-section-header>
      </div>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div class="section-wrapper margin-align" [ngClass]="getSectionLocked() !== true || !applicationId ? '' : 'disable-section'">
    <div class="top-bottom-margin section-column">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 section-field">
        <label class="ui-g-5 required">{{ 'technical-data.select-concept' | translate }}</label>
        <div class="ui-g-4 pl-0">
          <p-dropdown
            [options]="measuringConcepts"
            [(ngModel)]="technicalData.measuring_concept"
            name="measuring_concept"
            #measuring_concept="ngModel"
            optionValue="value"
            placeholder="-Select-"
            [disabled]="isSectionDisabled"></p-dropdown>
        </div>
      </div>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 section-field mb-2">
        <div class="ui-g-12" [innerHTML]="'grid-comp.disclaimer' | translate : { link: this.downloadCenterLink }"></div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 section-field">
        <label class="ui-g-5 required">
          {{ 'grid-comp.overview-circuit' | translate }}
        </label>
        <app-file-upload
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
          [fileData]="this.technicalData.circuit_diagram"
          [isDetailsView]="isDetailsView && technicalData.circuit_diagram.document_id"
          [type]="documentTypes.CircuitDiagram"
          [isClearButtonDisabled]="isSectionDisabled"
          [inputName]="'circuit_diagram'"
          [isRequired]="!isModeratorRole()"
          (clearFileEvent)="clearFile($event)"></app-file-upload>
      </div>
    </div>
  </div>
</div>
